var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attendee)?_c('h2',{staticClass:"text-center"},[_vm._v("WELCOME TO YOUR ITINERARY, "+_vm._s(_vm._f("uppercase")(_vm.attendee.name)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }